import styled from '../../theme/styled-with-theme';

import { Flexbox } from '../Flexbox';

export const Wrapper = styled('div')<{ bgColor: string }>`
  background-color: ${({ bgColor = '#FFFFFF' }) => bgColor};
  min-height: 100vh;
  min-height: -moz-available;
  min-height: -webkit-fill-available;
  min-height: fill-available;
`;

export const FixedHeader = styled(Flexbox)<{ isAffiliate?: boolean }>`
  flex-direction: column;
  justify-content: center;
  background-color: white;
  width: 100%;
  top: 0;

  ${({ isAffiliate = false }) =>
    isAffiliate
      ? `position: absolute;`
      : `
          position: fixed;
          z-index: 4;
        `}
`;
